/**
 * Bug-report feature — Mixpanel tracking definitions.
 *
 * Single source of truth for every Mixpanel event and action value emitted by
 * the bug-report feature. Prefer importing from here instead of using raw
 * string literals at call sites.
 *
 * Event: "bug report"
 * Properties:
 *   action    – BugReportTrackingAction member
 *   proj_uuid – project id (when available)
 *   value     – contextual payload (e.g. submission counts)
 */

export const BUG_REPORT_EVENT = 'bug report' as const

export enum BugReportTrackingAction {
  OPEN = 'open',
  SUBMIT = 'submit',
  REGION_CAPTURE = 'region capture',
}
